const ChevronRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <rect
      width="24"
      height="24"
      fill="#E2E2F7"
      fillOpacity="0.2"
      rx="12"
    ></rect>
    <path
      stroke="#024"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m10 16 4-4-4-4"
    ></path>
  </svg>
);

export default ChevronRight;
